import React, { Component } from "react";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  Row,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { layout, roles } from "../../../../common/constants";
import {
  DataTable,
  ExportCSV,
  MainLoader,
  TableRowField,
} from "../../../../components";
import { getAll as allProvidersExport } from "../../../../service/provider";
import {
  deleteProvider,
  getProviders,
  resetProviders,
} from "../../../../store/provider/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { exportExcel } from "./excel";
class ProviderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      loadingExport: false,
    };
    this.handleObtainProvidersExport =
      this.handleObtainProvidersExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.performGetProviders(true);
  }

  componentDidUpdate(prevProps) {
    this.checkProviderDelete(prevProps);
  }
  componentWillUnmount() {
    this.props.resetProviders();
  }
  performGetProviders(reset = false) {
    const { page, filter } = this.state;
    this.props.getProviders({ page, filter, reset });
  }

  async filterCategories() {
    await this.setState({ page: 1 });
    this.performGetProviders();
  }

  handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterCategories();
    }
  }

  async checkProviderDelete(prevProps) {
    if (
      prevProps.deletedProvider == null &&
      this.props.deletedProvider != null
    ) {
      toast.success("Proveedor eliminado satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetProviders();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetProviders();
  }

  performDeleteProvider(id) {
    Swal({
      title: "Eliminar proveedor",
      text: "¿Estás seguro que deseas eliminar al proveedor?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteProvider(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.SUPER_ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/providers/${row.id}/detail`
                )
              }
            >
              <i className="mr-1 fa fa-eye"></i> Detalle
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/providers/${row.id}/edit`
                )
              }
            >
              <i className="mr-1 fa fa-edit"></i> Editar
            </DropdownItem>
            <DropdownItem
              disabled={this.props.deleteLoading}
              onClick={() => this.performDeleteProvider(row.id)}
            >
              <i className="mr-1 fa fa-trash"></i> Eliminar
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    } else {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/providers/${row.id}/detail`
                )
              }
            >
              <i className="mr-1 fa fa-eye"></i> Detalle
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.providers}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainProvidersExport() {
    this.setState({ loadingExport: true });
    allProvidersExport(0, null)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Proveedor",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Código:" value={row.code} />
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="RUC:" value={row.ruc} />
              <TableRowField label="Teléfono:" value={row.phone} />
              <TableRowField label="Email:" value={row.email} />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "xs",
        text: "Proveedor",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Código:" value={row.code} />
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="RUC:" value={row.ruc} />
            </div>
          );
        },
      },
      {
        dataField: "phone",
        text: "Teléfono",
        style: { width: "120px" },
        headerStyle: { width: "120px" },
      },
      {
        dataField: "email",
        text: "Email",
        style: { width: "180px" },
        headerStyle: { width: "180px" },
      },
      columnOption,
    ];

    const columns = [
      {
        dataField: "code",
        text: "Código",
      },
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "ruc",
        text: "RUC",
      },
      {
        dataField: "phone",
        text: "Teléfono",
      },
      {
        dataField: "email",
        text: "Email",
      },
      columnOption,
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-share-alt"></i>Proveedores
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="8">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterCategories()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="4">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainProvidersExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="10">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterCategories()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col md="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainProvidersExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {this.props.role == roles.SUPER_ADMIN && (
              <Row className="mb-2">
                <Col>
                  <div className="float-right">
                    <Button
                      color="primary"
                      onClick={() =>
                        this.props.history.push("/administration/providers/add")
                      }
                    >
                      <i className="mr-1 fa fa-plus"></i> Nuevo
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { providers, error, loading, pageSize, total } =
    state.provider.providerList;

  return {
    providers,
    error,
    loading,
    pageSize,
    total,
    deletedProvider: state.provider.deleteProvider.provider,
    deleteError: state.provider.deleteProvider.error,
    deleteLoading: state.provider.deleteProvider.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProviders,
      deleteProvider,
      resetProviders,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderList/ProviderList.js